import { render, staticRenderFns } from "./categoryPop.vue?vue&type=template&id=020649a8&scoped=true"
import script from "./categoryPop.vue?vue&type=script&lang=js"
export * from "./categoryPop.vue?vue&type=script&lang=js"
import style0 from "./categoryPop.vue?vue&type=style&index=0&id=020649a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020649a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020649a8')) {
      api.createRecord('020649a8', component.options)
    } else {
      api.reload('020649a8', component.options)
    }
    module.hot.accept("./categoryPop.vue?vue&type=template&id=020649a8&scoped=true", function () {
      api.rerender('020649a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/home/components/categoryPop.vue"
export default component.exports